export function validateSignInEmailForCode(
  value: string,
  options?: { lockedInviteEmail?: string | null },
): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return 'Enter your email address.';
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
    return 'Enter a valid email address.';
  }
  const locked = options?.lockedInviteEmail?.trim();
  if (locked && trimmed.toLowerCase() !== locked.toLowerCase()) {
    return 'Sign in with the email address this trip invite was sent to.';
  }
  return null;
}
